import { SofiaEnvironment } from "@/sofia-environment"
import type { Country } from "@/types/__generated__/union-types"

export const isBetterDocAvailable = (country: Country | undefined) =>
  country === "CH" || (country === "DE" && !SofiaEnvironment.AreEndUsersOnEnvironment)
